import { get, post, put, del } from "../../helpers/apiWrapper";


// Get API for listing CMS files
export const getCmsFiles = async (params) => {
  const config = {
    params: params,
  };
  return await get(`/cms-files/list`, config);
};

// Post API for creating CMS file
export const createCmsFile = async (data) => {
  const config = {
    data: data,
   
  };
  return await post(`/cms-files/create`, config);
};

// Put API for updating CMS file
export const updateCmsFile = async (id, data) => {
  const config = {
    data: data,
   
  };
  return await put(`/cms-files/edit/${id}`, config);
};

// Delete API for removing CMS file
export const deleteCmsFile = async (id) => {
  return await del(`/cms-files/delete/${id}`);
};